import { Injectable } from "@angular/core";
import { Flow } from "./core/classes/flow";
import { SendCategorySender } from "./core/interfaces/company-custom-configuration";
import { SendTypeSendCategoryEnum } from "./core/interfaces/send-type-configuration";
import {
  EMAIL_STANDALONE_SEND_CATEGORY,
  OTP_STANDALONE_SEND_CATEGORY,
  PEC_STANDALONE_SEND_CATEGORY,
  SMS_STANDALONE_SEND_CATEGORY
} from "./core/classes/send-categories.constant";

@Injectable({
  providedIn: "root"
})
export class SendCategoryService {

  constructor() {
  }

  getCategorySenderByFlow(flow: Flow | null, sendCategorySenders: SendCategorySender[]): SendCategorySender | null {

    if (flow) {

      const sender: SendCategorySender | undefined = sendCategorySenders.find((elm: SendCategorySender) => this.getChannelBySendCategory(flow).includes(elm.SendCategory!));

      if (sender) return sender;

    }

    return null;

  }

  getChannelBySendCategory(flow: Flow): SendTypeSendCategoryEnum[] {

    if(flow.SendTypeConfigurationSendTypeSendCategory === SendTypeSendCategoryEnum.PEC) return PEC_STANDALONE_SEND_CATEGORY;

    if(flow.SendTypeConfigurationSendTypeSendCategory === SendTypeSendCategoryEnum.Email) return EMAIL_STANDALONE_SEND_CATEGORY;

    if(flow.SendTypeConfigurationSendTypeSendCategory === SendTypeSendCategoryEnum.SMS) return SMS_STANDALONE_SEND_CATEGORY;

    if(flow.SendTypeConfigurationSendTypeSendCategory === SendTypeSendCategoryEnum.OTPLetter) return OTP_STANDALONE_SEND_CATEGORY;

    return [];

  }

  /**
   * Restituisce i sender configurati il cui SendCategory corrisponde ESATTAMENTE alla
   * SendCategory effettiva del flow corrente.
   *
   * Differisce volutamente da {@link getCategorySenderByFlow}, che internamente sfrutta
   * {@link getChannelBySendCategory} (la quale per la category Email include anche PEC,
   * cfr. workaround documentato in send-categories.constant.ts). Per la lista mittenti
   * lato component PersonSpecifications serve un filtro stretto: per flow Email solo
   * sender Email, per flow PEC solo sender PEC.
   */
  getCategorySendersByFlow(flow: Flow | null, sendCategorySenders: SendCategorySender[]): SendCategorySender[] {

    if (!flow || !flow.SendTypeConfigurationSendTypeSendCategory) return [];

    return sendCategorySenders.filter((elm: SendCategorySender) => elm.SendCategory === flow.SendTypeConfigurationSendTypeSendCategory);

  }

}
